import { useMelwaysInfo } from '@seek/melways-react';
import { CUSTOMER_SERVICE_HOURS } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';

import type { Site } from 'src/shared/types';

import translations from '../../.vocab';

const CustomerServiceHours = () => {
  const { site, language } = useMelwaysInfo();
  const { t } = useTranslations(translations);

  if (language !== 'en') {
    return <Text>{t('Customer service hours')}</Text>;
  }

  return <Text>{CUSTOMER_SERVICE_HOURS[site as Site]}</Text>;
};

export default CustomerServiceHours;
